import { render, staticRenderFns } from "./sds-sheets-en.vue?vue&type=template&id=3f037c96&"
import script from "./sds-sheets-en.vue?vue&type=script&lang=js&"
export * from "./sds-sheets-en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports